import { useEffect, useRef } from 'react'
import { animateSetupLandingIn } from './setupLandingAnimations'

export const useSetupLandingAnimation = () => {
  const headingRef = useRef<HTMLDivElement>(null)
  const subtitleRef = useRef<HTMLDivElement>(null)
  const ctaRef = useRef<HTMLDivElement>(null)
  const cardRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const timeline = animateSetupLandingIn({
      heading: headingRef.current,
      subtitle: subtitleRef.current,
      cta: ctaRef.current,
      card: cardRef.current,
    })
    return () => {
      timeline?.kill()
    }
  }, [])

  return { headingRef, subtitleRef, ctaRef, cardRef }
}
